'use es6';

import FacsimileInboxRecord from '../data/FacsimileInboxRecord';
const inboxFilter = (portalId, emailAddress) => {
  const normalizedEmail = emailAddress.toLowerCase();
  return inboxRecord => inboxRecord && inboxRecord.portal_id === portalId && inboxRecord.email_address && inboxRecord.email_address.toLowerCase() === normalizedEmail;
};
export const getInboxByEmail = (portalId, emailAddress) => inboxes => inboxes.get('inboxes').toJS().find(inboxFilter(portalId, emailAddress));
export const getFacsimileInboxes = rawFacsimileResponse => rawFacsimileResponse.get('inboxes').map(FacsimileInboxRecord);